import { useContext, useEffect, useState } from 'react';

import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';

import { ClassifierContext } from '../../context/classifier/ClassifierContext';

import Message from '../../components/ui/Message';



export const ClassifierValuePage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;

    const { addValue, updateValue } = useContext(ClassifierContext);


    const [isFormValid, setIsFormValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');



    const classifier =
        state.classifier;


    let value;

    if (state.value) {

        value = state.value;

    } else {

        value = {

            valueCode: '',
            valueName: ''

        };

    }



    const {

        formState,
        onInputChange

    } = useForm(value);



    const {

        valueCode,
        valueName

    } = formState;



    useEffect(() => {

        const valid =
            valueCode.length > 0;

        setIsFormValid(valid);

    }, [valueCode]);



    const handleSave = async () => {

        let resp = "";

        if (state.value) {
            resp = await updateValue(classifier.classifierId, formState);
        } else {
            resp = await addValue(classifier.classifierId, formState);
        }


        if (resp === "success") {
            setSuccessMessage(
                state.value
                    ?
                    "Valor actualizado correctamente"
                    :
                    "Valor creado correctamente"
            );

        }
        else {
            setErrorMessage(resp);
        }

    }



    const removeError = () => { setErrorMessage(''); }



    const removeSuccessMessage = () => {

        setSuccessMessage('');
        navigate(-1);

    }



    return (

        <div className='container d-flex align-items-center justify-content-center mt-5'
            style={styles.container}>



            <div className='col-md-6'>



                <h3>

                    {

                        state.value

                            ?

                            'Actualizar valor'

                            :

                            'Crear valor'

                    }

                </h3>



                <h6 className="text-muted">

                    Clasificador:

                    {" "}

                    <b>

                        {classifier.name}

                    </b>

                </h6>



                <hr />



                <form className="row g-3">



                    {/* Código */}

                    <div className="mb-3">

                        <label className="form-label">

                            Código valor

                        </label>


                        <input

                            type="text"

                            className={`form-control ${valueCode
                                ?
                                'is-valid'
                                :
                                'is-invalid'
                                }`}


                            name="valueCode"

                            value={valueCode}

                            onChange={onInputChange}


                            disabled={state.value}

                            placeholder="Código"

                        />

                    </div>



                    {/* Nombre */}

                    <div className="mb-3">

                        <label className="form-label">

                            Nombre valor

                        </label>


                        <input

                            type="text"

                            className="form-control"

                            name="valueName"

                            value={valueName}

                            onChange={onInputChange}

                            placeholder="Valor"

                        />

                    </div>



                    <div className='container d-flex align-items-center justify-content-center mt-5'>


                        <button

                            type="button"

                            className="btn btn-outline-secondary"

                            onClick={() => navigate(-1)}

                        >

                            Atrás

                        </button>



                        <button

                            type="button"

                            className="btn btn-primary ms-5"

                            disabled={!isFormValid}

                            onClick={handleSave}

                        >

                            Guardar

                        </button>


                    </div>



                </form>


                <div style={{ height: '100px' }}></div>



            </div>



            {

                errorMessage.length > 0

                    ?

                    <Message
                        type='error'
                        message={errorMessage}
                        closeDialog={removeError}
                        handleOk={removeError}
                        backgroundColor='rgba(0,0,0,0.4)'
                    />

                    :

                    ''

            }



            {

                successMessage.length > 0

                    ?

                    <Message
                        type='success'
                        title='Exitoso'
                        message={successMessage}
                        closeDialog={removeSuccessMessage}
                        handleOk={removeSuccessMessage}
                        backgroundColor='rgba(0,0,0,0.4)'
                    />

                    :

                    ''

            }



        </div>

    );

}



const styles = {

    container: {

        flex: 1,
        marginTop: 10,
        marginHorizontal: 20

    }

};